export default {"src":"/_next/static/media/copy_icon.e906233c.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};